/**
 * Writing Styles - Traditional Chinese Localization
 */

export default {
    writingStyles: {
        title: '撰寫風格',
        description: '管理您的專利撰寫風格',

        // Actions
        actions: {
            create: '創建風格',
            edit: '編輯',
            delete: '刪除',
            preview: '預覽',
            duplicate: '複製',
            export: '匯出',
            favorite: '添加到收藏',
            unfavorite: '取消收藏',
            selectFile: '選擇檔案',
            uploadFile: '上傳檔案',
            download: '下載',
            cancel: '取消',
            save: '儲存',
            saving: '儲存中...',
            confirm: '確認',
            viewAll: '查看全部',
            collapseAll: '全部摺疊',
            expandAll: '全部展開',
            sort: '排序',
            more: '更多',
        },

        // Tabs
        tabs: {
            all: '全部',
            public: '公開',
            private: '私有',
            favorites: '收藏',
        },

        // Filters
        filters: {
            region: '地區',
            allRegions: '所有地區',
            sourceType: '來源類型',
            allSources: '所有來源',
            search: '搜尋風格...',
        },

        // View Modes
        viewMode: {
            grid: '網格視圖',
            list: '列表視圖',
        },

        // Categories
        categories: {
            all: '全部分類',
            public: '公開',
            private: '私有',
            system: '系統預設',
            custom: '用戶自定義',
            SYSTEM: '系統預設',
            CUSTOM: '用戶自定義',
            favorites: '收藏',
            FAVORITES: '收藏',
        },

        // Source Types
        sourceTypes: {
            reference: '專利與文檔',
            upload: '檔案上傳',
            manual: '手動輸入',
            pdf: 'PDF 上傳',
            word: 'Word 上傳',
            patent_number: '專利號',
            patentNumber: '專利號',
        },

        // Regions
        regions: {
            all: '所有地區',
            USPTO: '美國',
            us: '美國',
            CNIPA: '中國',
            cn: '中國',
            EPO: '歐洲',
            ep: '歐洲',
            JPO: '日本',
            jp: '日本',
            KIPO: '韓國',
            kr: '韓國',
            WIPO: 'WIPO',
            wipo: 'WIPO',
            PCT: '國際 (PCT)',
        },

        // Sections
        sections: {
            title: '標題',
            titlePlaceholder: '請輸入專利標題',
            abstract: '摘要',
            abstractPlaceholder: '請輸入專利摘要',
            background: '背景技術',
            backgroundPlaceholder: '請輸入背景技術',
            summary: '發明內容',
            summaryPlaceholder: '請輸入發明內容',
            description: '具體實施方式',
            descriptionPlaceholder: '請輸入具體實施方式',
            claims: '權利要求',
            claimsPlaceholder: '請輸入權利要求',
        },

        // Dialog
        dialog: {
            createStyle: '創建撰寫風格',
            editStyle: '編輯撰寫風格',
            createStyleDesc: '從已公開的專利中學習，構建您的撰寫風格',
            styleName: '風格名稱',
            styleNamePlaceholder: '輸入風格的描述性名稱',
            description: '描述',
            descriptionPlaceholder: '輸入簡短描述（可選）',
            region: '地區',
            category: '分類',
            visibility: '可見性',
            public: '團隊可見',
            private: '僅自己',
            publicDesc: '對所有團隊成員可見',
            privateDesc: '僅對您可見',
            sourceType: '來源類型',
            manualDesc: '手動輸入每個部分',
            pdfDesc: '上傳 PDF 檔案提取內容',
            wordDesc: '上傳 Word 文檔提取內容',
            patentNumberDesc: '從專利號獲取內容',
            uploadFile: '參考文檔',
            dragDropOrClick: '點擊或拖曳檔案到此處上傳',
            pdfWordSupport: '支援 PDF 和 Word 文檔（最大 50MB）',
            pdfOnly: '僅支援 PDF 檔案（最大 50MB）',
            wordOnly: '僅支援 Word 文檔（最大 50MB）',
            selectFile: '選擇檔案',
            uploading: '上傳中...',
            patentNumber: '參考專利',
            patentNumberPlaceholder: '例如：US1234567A、CN201910123456A',
            fetch: '獲取',
            sections: '專利章節',
            sectionsHint: '配置每個章節的內容',
            expandAll: '展開全部',
            collapseAll: '收起全部',
            sectionPlaceholder: '輸入此章節的內容...',
            required: '必填',
            chars: '字元',
            cancel: '取消',
            create: '創建風格',
            save: '儲存更改',
            saveChanges: '儲存更改',
            saving: '儲存中...',

            // Selected sources summary
            selectedPatentsCount: '已選擇 {count}/{max} 篇專利',
            selectedFilesCount: '{count} 個檔案',
            unsavedChangesTitle: '未儲存的修改',
            unsavedChangesMessage: '您有未儲存的修改，確定要關閉嗎？關閉後修改將遺失。',
            discardChanges: '放棄修改',
            continueEditing: '繼續編輯',
            styleCreated: '風格已建立',
            styleCreatedSuccess: '風格已成功建立！您可以關閉對話框返回列表查看。',
            minPatentsRequired: '至少需要2篇專利',
            maxPatentsExceeded: '已超過專利數量上限',
            minFilesRequired: '至少需要2篇文件',
            maxFilesExceeded: '已超過文件數量上限',
            selectPatentsFirst: '請先選擇專利',
            patentLimitReached: '已達到專利數量上限（5篇）',

            // Visibility Dialog
            changeVisibility: '更改可見性權限',
            visibilityDescription: '選擇此撰寫風格的可見性設定。私有風格僅對您可見，公開風格對團隊所有成員可見。',
            teamVisible: '團隊可見',
            teamVisibleDesc: '對團隊所有成員可見',
            privateVisible: '僅自己',
            privateVisibleDesc: '僅對創建者可見',
            changeToPublicWarning: '更改為團隊可見後，您團隊的所有成員都可以查看和使用此風格。',
            changeToPrivateWarning: '更改為僅自己可見後，只有您可以查看和使用此風格。',

            // Level selection (Super Admin only)
            level: '可見性',
            adminOnly: '僅管理員',
            systemLevel: '系統級',
            userLevel: '用戶級',
            systemLevelDesc: '對所有用戶可見',
            userLevelDesc: '僅自己可見',
        },

        // Create Dialog (legacy - for backward compatibility)
        createDialog: {
            title: '創建撰寫風格',
            editTitle: '編輯撰寫風格',
            basicInfo: '基本資訊',
            name: '名稱',
            namePlaceholder: '輸入風格名稱',
            nameRequired: '名稱為必填項',
            description: '描述',
            descriptionPlaceholder: '輸入風格描述（可選）',
            region: '地區',
            regionPlaceholder: '選擇地區',
            regionRequired: '地區為必填項',
            category: '分類',
            categoryPlaceholder: '選擇分類',
            tags: '標籤',
            tagsPlaceholder: '添加標籤（按回車）',

            sourceMethod: '來源方式',
            selectSourceMethod: '選擇創建風格的方式',
            manualInput: '手動輸入',
            manualInputDesc: '手動輸入每個部分的內容',
            uploadPdf: '上傳 PDF',
            uploadPdfDesc: '上傳 PDF 檔案並提取內容',
            uploadWord: '上傳 Word',
            uploadWordDesc: '上傳 Word 文檔並提取內容',
            patentNumber: '專利號',
            patentNumberDesc: '從專利號獲取內容',

            patentNumberLabel: '專利號',
            patentNumberPlaceholder: '輸入專利號（如：US1234567A）',
            patentNumberFetch: '獲取專利',
            patentNumberFetching: '獲取中...',

            fileUpload: '檔案上傳',
            fileUploadDrag: '點擊或拖曳檔案到此區域上傳',
            fileUploadHint: '支援 PDF 和 Word 檔案，最大 50MB',
            fileUploading: '上傳中...',
            fileProcessing: '處理檔案中...',
            fileProcessed: '檔案處理成功',

            sectionContent: '章節內容',
            sectionContentDesc: '編輯每個章節的內容',
            sectionRequired: '必填',
            sectionOptional: '可選',
            sectionPlaceholder: '輸入 {section} 的內容',
            sectionEmpty: '無內容',
        },

        // Preview Dialog
        preview: {
            title: '預覽撰寫風格',
            loading: '載入預覽中...',
            wordDocument: 'Word 文檔',
            patentNumber: '專利號',
            noContent: '暫無內容',
            resetZoom: '重置縮放',
            sections: '章節',
            usageCount: '使用次數',
            lastUpdated: '最後更新',
        },
        previewDialog: {
            title: '預覽撰寫風格',
            loading: '載入預覽中...',
            sourceInfo: '來源資訊',
            sourceType: '來源類型',
            fileName: '檔案名',
            patentNumber: '專利號',
            fileSize: '檔案大小',
            uploadDate: '上傳日期',
            openFile: '打開檔案',
            sections: '章節',
        },

        // Empty States
        empty: {
            noStyles: '暫無撰寫風格',
            createFirstStyle: '創建您的第一個撰寫風格以開始使用',
            noResults: '未找到風格',
            tryDifferentFilters: '嘗試調整篩選條件或搜尋詞',
            noStylesFound: '未找到撰寫風格',
        },
        emptyState: {
            title: '暫無撰寫風格',
            description: '創建您的第一個撰寫風格以開始使用',
            createButton: '創建風格',
            noResults: '未找到風格',
            noResultsDesc: '嘗試調整篩選條件或搜尋詞',
        },

        // Stats
        stats: {
            total: '總風格數',
            public: '公開風格',
            private: '私有風格',
            system: '系統風格', // ✅ 新增
            custom: '自定義風格', // ✅ 新增
            favorites: '收藏風格',
        },

        // Delete Confirmation
        delete: {
            title: '刪除撰寫風格',
            message: '確定要刪除 "{name}" 嗎？',
            confirm: '刪除',
            cancel: '取消',
        },

        // Editor
        editor: {
            createTitle: '新建撰寫風格',
            editTitle: '編輯撰寫風格',
            basicInfo: '基本資訊',
            sourceType: '來源類型',
            referenceDoc: '參考文檔',
            manualInput: '手動輸入',
            patentNumber: '專利號',
            patentNumberPlaceholder: '例如：US1234567A、CN201910123456A',
            fetch: '獲取',
            uploadFile: '上傳檔案',
            uploadTitle: '點擊或拖曳專利文檔到此處上傳',
            uploadHint: '上傳專利文檔作為撰寫風格參考 — 支援 PDF 和 Word（最大 50MB）',
            fileProcessing: '解析中...',
            fileCompleted: '解析完成',
            fileFailed: '解析失敗',
            loadingPatentData: '正在載入專利資訊...',
            patentDataLoaded: '專利資訊載入成功',
            searchFailed: '搜尋失敗',
            patentDataLoadSuccess: '專利資訊載入成功',
            patentDataLoadFailed: '載入專利資訊失敗',
            fileUploadedHint: '已上傳檔案，無法輸入專利號',
            patentNumberEnteredHint: '已輸入專利號，無法上傳檔案',
            generateStyle: '生成風格',
            generateSuccess: '風格生成成功',
            generateFailed: '風格生成失敗',
            manualEditMode: '已進入手動編輯模式',
            manualInputHint: '選擇手動輸入後，您可以直接在右側編輯器中編寫風格內容',
            emptyTitle: '開始創建您的撰寫風格',
            emptyDescription: '填寫左側的基本資訊，選擇參考文檔或手動輸入，然後點擊「生成風格」按鈕',
            sectionsTitle: '編輯撰寫風格內容',
            sectionsHint: '請填寫各個部分的內容。標記為必填的部分必須填寫。',
            previewTitle: '風格內容預覽',
            patentTitle: '標題',
            patentAbstract: '摘要',
            patentClaims: '權利要求',
            patentDescription: '說明書',
            autoCreate: '分析並創建',
        },

        // Messages
        messages: {
            createSuccess: '撰寫風格創建成功',
            createError: '創建撰寫風格失敗',
            updateSuccess: '撰寫風格更新成功',
            updateError: '更新撰寫風格失敗',
            saveError: '儲存撰寫風格失敗',
            deleteSuccess: '撰寫風格刪除成功',
            deleteError: '刪除撰寫風格失敗',
            deleteConfirm: '確定要刪除 "{name}" 嗎？',
            deleteConfirmDesc: '此操作不可撤銷',
            favoriteSuccess: '已添加到收藏',
            unfavoriteSuccess: '已取消收藏',
            toggleFavoriteError: '切換收藏失敗',
            duplicateSuccess: '撰寫風格複製成功',
            duplicateError: '複製撰寫風格失敗',
            fileUploadSuccess: '檔案上傳成功',
            fileUploadError: '檔案上傳失敗',
            patentFetchSuccess: '專利資訊獲取成功',
            patentFetchError: '獲取專利資訊失敗',
            validationError: '請填寫所有必填項',
            sectionValidationError: '請填寫所有必填章節',
        },

        // Card Info
        card: {
            usedTimes: '使用 {count} 次',
            lastModified: '修改於 {time}',
            createdBy: '創建者 {name}',
        },

        // Patent Search Dialog
        patentSearch: {
            title: '檢索專利',
            placeholder: '輸入專利號，如：US11739015B2、CN201910123456A',
            placeholderMultiline: '貼上或輸入專利號，每行一個，也可用逗號、分號或空格分隔\n例如：\nCN222815419U\nCN222619343U\nCN220672152U',
            search: '檢索',
            hint: '輸入專利號檢索 — AI 將分析其撰寫模式，構建您的風格',
            hintBatch: '支援批次檢索：多個專利號可用逗號、分號、空格或換行分隔',
            searching: '檢索中...',
            noResults: '未找到相關專利',
            searchSuccess: '前{count} 篇相關專利',
            searchFailed: '檢索失敗，請稍後重試',
            batchSearching: '正在批次檢索 {count} 個專利...',
            batchSearchSuccess: '批次檢索完成：成功 {success} 個，失敗 {failed} 個，共找到 {total} 個專利',
            selectedCount: '已選擇 {count} 個專利',
            selectAtLeastOne: '請至少選擇一個專利',
            loadDetailsFailed: '載入專利詳情失敗',
            enterPatentNumber: '請輸入專利號',
            recognizedCount: '識別到 {count} 個專利號',
            recognizedCountDedup: '識別到 {count} 個專利號（已去重，原始 {original} 個）',
            duplicatesRemoved: '已自動去除 {count} 個重複項',
            batchResultTitle: '批次檢索結果',
            batchAutoAdded: '已自動添加 {count} 篇專利到已選列表',
            notFound: '未找到',
            patentAlreadySelected: '該專利已在已選列表中',
        },

        // Extraction Progress
        extraction: {
            steps: {
                submitting: '提交風格提取任務',
                fetchingData: '獲取專利章節資料',
                analyzing: 'AI 分析撰寫風格',
                complete: '提取完成',
            },
            waitingTime: '已等待 {time}',
            estimatedTime: '通常需要 1-2 分鐘',
            cancel: '取消提取',
            cancelConfirm: '確定要取消當前提取任務嗎？',
            cancelled: '已取消提取任務',
            contextPatents: '正在分析的專利',
            contextFiles: '正在分析的檔案',
            submittingTask: '正在提交風格提取任務...',
            fetchingSectionData: '正在獲取專利章節資料...',
            analyzingStyle: 'AI正在分析專利，提取撰寫風格...',
            analyzingStyleProcessing: 'AI正在分析專利，提取撰寫風格...（處理中）',
        },
    },
};
